import { useState } from 'react';
import './Safety.css';
import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
//import JoinPriorityWaitlistBtn from '../../ViralLoops/JoinPriorityWaitlistBtn';
import 'react-phone-number-input/style.css'


const Safety = () => {

    const [showWaitlist, setShowWaitlist] = useState(false);

    return(
        <section className='safetyMain'>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="safetyInner">
                        <h2>Every aspect of trust, safety & risk all in one place</h2>
                        <p>experience how advanced verification and risk tools can enhance your rental operation.</p>
                        <div className="safetyBtn">
                                <a className="btn white" href="/general-question">Contact Sales</a>
                                {/* <JoinPriorityWaitlistBtn buttonclass="btn btnGradient" buttonText="Join The Waitlist" iconSrc="/img/arrow_spl.svg" /> */}
                                <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                            <button onClick={() => setShowWaitlist(true)} className="btn btnGradient">
                                Join The Waitlist
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Safety;